import React, {createContext, useCallback, useMemo, useState} from 'react';
import {StyleSheet, View} from 'react-native';
import {colors} from '../../config/theme';
import {
  DESKTOP_PANEL_WIDTH,
  useDesktopLayout,
} from '../../utility/useDesktopLayout';

// On desktop web, bottom sheets (the station list on the map screens) become a
// fixed panel to the right of the screen instead of covering the map. This
// host reserves that column; web/shims/bottom-sheet.js renders the focused
// screen's sheet content into it. On mobile the column is never shown.
export const DesktopSidePanelContext = createContext(null);

export const DesktopSidePanelHost = ({children}) => {
  const isDesktop = useDesktopLayout();
  const [slot, setSlot] = useState(null);
  const [users, setUsers] = useState(0);

  const register = useCallback(() => {
    setUsers(n => n + 1);
    return () => setUsers(n => n - 1);
  }, []);
  const value = useMemo(
    () => ({slot: isDesktop ? slot : null, register}),
    [isDesktop, slot, register],
  );

  // Same tree on every size, so crossing the breakpoint never remounts the
  // navigators (and loses their state).
  return (
    <DesktopSidePanelContext.Provider value={value}>
      <View style={styles.row}>
        <View style={styles.main}>{children}</View>
        <View
          ref={setSlot}
          style={[styles.panel, !(isDesktop && users > 0) && styles.hidden]}
        />
      </View>
    </DesktopSidePanelContext.Provider>
  );
};

const styles = StyleSheet.create({
  row: {flex: 1, flexDirection: 'row'},
  main: {flex: 1},
  panel: {
    width: DESKTOP_PANEL_WIDTH,
    backgroundColor: colors.surface,
    borderLeftWidth: 1,
    borderLeftColor: colors.border,
  },
  hidden: {display: 'none'},
});
